import type { Adventure } from '../../types'

// Age 4-5: Addition Explorer - Sums up to 10
export const additionExplorerAdventure: Adventure = {
  id: 'addition-explorer',
  title: 'Addition Explorer',
  theme: 'addition',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hey explorer! I'm Tilly! Let's go on an addition adventure! Adding numbers is like putting things together!",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look! I have 4 red blocks and 3 blue blocks. How many blocks do I have in total? Let's add them together!",
      duration: 6,
      background: 'number-world'
    },
    choice1: [
      {
        id: 'add-blocks',
        label: "Let's add!",
        tillyLine: "Adding is fun! 4 plus 3 equals... what?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '4 + 3 = ?',
      tillyPrompt: 'What is 4 plus 3? Count the blocks!',
      options: [
        { id: '6', label: '6', isCorrect: false },
        { id: '7', label: '7', isCorrect: true },
        { id: '8', label: '8', isCorrect: false }
      ],
      num1: 4,
      num2: 3
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Amazing! Now I see 5 yellow stars and 2 green stars. How many stars altogether?",
      duration: 5,
      background: 'night-sky'
    },
    choice2: [
      {
        id: 'count-stars',
        label: "Count the stars!",
        tillyLine: "5 stars plus 2 more stars... let's find the answer!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '5 + 2 = ?',
      tillyPrompt: '5 plus 2 equals what?',
      options: [
        { id: '6', label: '6', isCorrect: false },
        { id: '7', label: '7', isCorrect: true },
        { id: '8', label: '8', isCorrect: false }
      ],
      num1: 5,
      num2: 2
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're an addition expert! Ready for the BIG challenge? 6 plus 4!",
        duration: 5,
        background: 'math-forest'
      },
      quizzes: [
        {
          id: 'challenge-quiz-1',
          type: 'simple-addition',
          question: '6 + 4 = ?',
          tillyPrompt: 'What is 6 plus 4?',
          options: [
            { id: '9', label: '9', isCorrect: false },
            { id: '10', label: '10', isCorrect: true },
            { id: '11', label: '11', isCorrect: false }
          ],
          num1: 6,
          num2: 4
        } as any
      ]
    },
    reward: {
      tillyLine: "Incredible! You solved them all! You're officially an Addition Explorer! Here's your badge!",
      badgeName: 'Addition Explorer',
      badgeIcon: '➕',
      nextPreview: 'Next time, we\'ll subtract numbers!'
    }
  }
}

// Tilly reactions for addition adventures
export const tillyAdditionCorrect = [
  "That's the right answer! You know your sums!",
  "Yes! Adding is your superpower!",
  "Bingo! You added those numbers perfectly!",
  "Correct! You're an addition whiz!",
  "Spot on! Keep those sums coming!",
  "You got it! Math is so much fun with you!",
  "Perfect addition! You're getting so good at this!",
  "Yes yes yes! You added them up!"
]

export const tillyAdditionWrong = [
  "Not quite! Let's count together to check!",
  "Almost! Try adding again slowly!",
  "Good try! Count on your fingers if it helps!",
  "That's not it, but you're learning! Let's try once more!",
  "Oops! Adding takes practice - you'll get it!",
  "Not that one! Let's think: put the numbers together!",
  "Keep trying! Addition is tricky at first!"
]
